import axios from 'axios';
axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
export default {
    namespaced: true,
    state: {
        authUser: {},
        isAuth: false, // Indica si existe un usuario autenticado
    },
    mutations: {
        SET_USER(state, user){
            state.authUser = user;
            state.isAuth = Boolean(Object.keys(user).length); // Si el objeto pasado tiene contenido, devuelve true e indica que el usuario está autenticado
            sessionStorage.setItem('isAuth', state.isAuth);
        }
    },
    actions: {
        async getEstado({commit}){
            if(sessionStorage.getItem("isAuth") != null){
                let respuesta = await axios.get('/api/user');
                commit('SET_USER', respuesta.data);
            }
        },
        setUser({commit}, user){
            commit('SET_USER', user);
        },
    }
}